import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { BookFormValues, bookSchema } from "@modules/books/validations/bookSchema";
import { useEditBookMutation } from "@modules/books/services/mutations";

export function useBookEditForm() {
  const { id } = useParams();
  const { mutateAsync, isPending } = useEditBookMutation(id as string);

  const methods = useForm<BookFormValues>({
    resolver: zodResolver(bookSchema),
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
